export default "__VITE_ASSET__pIlLsj4O__"